// Pictographs plus the parts of emoji sequences: flags, skin tones, joiners,
// variation selectors, keycaps. For places that speak in plain text (the
// brief, the assistant's log), where a habit's emoji would be the loudest
// thing on the screen
export const withoutEmoji = (text) => String(text)
  .replace(/[\p{Extended_Pictographic}\p{Regional_Indicator}\p{Emoji_Modifier}‍️⃣]/gu, '')
  .replace(/\s+/g, ' ')
  .replace(/ ([:;,.!?])/g, '$1') // "DARE ❌: done" reads "DARE: done"
  .trim();

// The assistant never writes dashes (the user can't stand them); its prompt
// says so, and this catches any that slip through before they're shown.
// Ranges read "9 to 5", dash bullets become dots, and a dash between clauses
// becomes a comma. Hyphens inside words ("check-in") stay
export const withoutDashes = (text) => String(text)
  // "9–5", "9am – 5pm", "Aug 1 – Sep 3", and the same with a spaced hyphen
  .replace(/(\d(?::\d{2})?(?:\s?[ap]m)?)(?:\s*[–—]\s*|\s+-\s+)(?=\d|(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\b)/gi, '$1 to ')
  // An unspaced hyphen between hours or small numbers ("9-5", "7:30-8am"),
  // but not inside a date like 2026-09-25 or a longer number
  .replace(/(?<![\d-])(\d{1,2}(?::\d{2})?(?:\s?[ap]m)?)-(?=\d{1,2}(?::\d{2})?(?:\s?[ap]m)?(?![\d-]))/gi, '$1 to ')
  .replace(/^(\s*)[-–—]\s+/gm, '$1• ')
  .replace(/[ \t]+[–—-][ \t]+/g, ', ')
  .replace(/[–—]/g, ', ')
  .replace(/ {2,}/g, ' ')
  .replace(/,\s*([.,;:!?])/g, '$1')
  .replace(/,\s*$/gm, '.');
